import { render, staticRenderFns } from "./ReqTrasladoLocComponent.vue?vue&type=template&id=c1e6e292&"
import script from "./ReqTrasladoLocComponent.vue?vue&type=script&lang=js&"
export * from "./ReqTrasladoLocComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports